import React, { useEffect, useState } from "react";
import Layout from "../../../components/dashboard/Layout";
import { useDispatch } from "react-redux";
import SearchBar from "../../../containers/admin/lectures/searchbar";
import LecturesTable from "../../../containers/admin/lectures/table";
import { getAllLecturesRequest } from "../../../modules/admin-modules/lectures/Actions";
import AddLecture from "../../../containers/admin/lectures/models/add-lecture";
import { useSuperAdminSubjectFilter } from "../../../helpers/useSuperAdminSubjectFilter";

const Lectures = () => {
  const [isAdd, setAdd] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const dispatch = useDispatch();
  const {
    isSuperAdmin,
    selectedSubjectId,
    setSelectedSubjectId,
    subjectQuery,
    canFetch,
  } = useSuperAdminSubjectFilter();

  useEffect(() => {
    if (!canFetch) return;
    dispatch(getAllLecturesRequest(subjectQuery));
  }, [canFetch, selectedSubjectId, dispatch]);

  return (
    <Layout>
      <SearchBar
        setAdd={setAdd}
        setSelectedData={setSelectedData}
        isSuperAdmin={isSuperAdmin}
        selectedSubjectId={selectedSubjectId}
        setSelectedSubjectId={setSelectedSubjectId}
      />
      <LecturesTable
        setAdd={setAdd}
        setSelectedData={setSelectedData}
        hideList={isSuperAdmin && !selectedSubjectId}
      />
      <AddLecture
        isAdd={isAdd}
        data={selectedData}
        setSelectedData={setSelectedData}
        selectedSubjectId={selectedSubjectId}
      />
    </Layout>
  );
};

export default Lectures;
